import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  useDisclosure,
  useMediaQuery,
} from "@chakra-ui/react";
import { capitalize } from "lodash";
import React, { ReactNode, useContext } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import HeaderLayout from "../components/layout/HeaderLayout";
import { GET_USER } from "../components/modals/user/update/queries";
import UserUpdate from "../components/modals/user/update/UserUpdate";
import { AuthContext } from "../context/AuthContext";

type UserLayoutProps = {
  children: ReactNode;
};

const UserLayout = (props: UserLayoutProps) => {
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
  const location = useLocation();
  const isPublic = location.pathname.split("/").includes("public");
  const { auth }: any = useContext(AuthContext);

  const isAddressExists = true;

  const {
    isOpen: isUpdateProfileModalOpen,
    onOpen: onOpenUpdateProfileModal,
    onClose: onCloseUpdateProfileModal,
  } = useDisclosure();

  return (
    <Box>
      <Helmet>
        <title>Freeshu | Dashboard</title>
      </Helmet>
      {!isPublic && <HeaderLayout />}

      <Box p={isLargerThan900 ? "10" : "1"}>{props.children}</Box>
      <UserUpdate
        isOpen={isUpdateProfileModalOpen}
        onOpen={onOpenUpdateProfileModal}
        onClose={onCloseUpdateProfileModal}
        id={auth?.id}
        title={`${capitalize(auth?.user?.name)} | Profile`}
      />
    </Box>
  );
};

export default UserLayout;
